import { MrbBaseRouteStore } from "mrb/core";
import { ArtistUploadService, ProducerUserAccountService } from "common/services";

class ProducerUploadContentRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.artistUploadService = rootStore.createApplicationService(ArtistUploadService);
        this.producerUserAccountService = rootStore.createApplicationService(ProducerUserAccountService);
    }

    async getProducers() {
        const response = await this.producerUserAccountService.getProducers();
        return response.data;
    }

    async createUploadSession(producerId, data) {
        const response = await this.artistUploadService.createUploadSession(producerId, data);
        return response.data;
    }

    async completeUploadSession(producerId, sessionId) {
        const response = await this.artistUploadService.completeUploadSession(producerId, sessionId);
        return response.data;
    }

    async getLatestUploadSession(producerId) {
        const response = await this.artistUploadService.getLatestUploadSession(producerId);
        return response.data || null;
    }
}

export default ProducerUploadContentRouteStore;
